import { MINUTE_IN_MILLISECONDS } from 'shared/utils/date-utils';

const getShiftDurationInMs = (start: Date, end: Date, breakTimeInMinutes = 0) => {
  return end.getTime() - start.getTime() - breakTimeInMinutes * MINUTE_IN_MILLISECONDS;
};

export { getShiftDurationInMs };
